import { FormattedMessage } from "react-intl";
import { NavLink } from "react-router-dom";

import useToggles from "../../../../shared/toggles/toggles";
import { MenuItemType } from "../../services/menuItems";
import NavbarService from "../../services/NavbarService";
import { prefetchModule } from "../../services/prefetch";

import { useMainMenuStyles } from "./MainMenu.styles";

interface Props {
  menuItem: MenuItemType;
  farmId: string;
  mobile?: boolean;
}

const MainMenuItem = ({ farmId, menuItem, mobile = false }: Props) => {
  const classes = useMainMenuStyles();
  const [, , isToggleActive] = useToggles();
  const Icon = NavbarService.getMenuItemIcon(menuItem.id);

  if (menuItem.toggleId && !isToggleActive(menuItem.toggleId)) {
    return null;
  }

  const handlePrefetch = () => {
    prefetchModule(menuItem.route);
  };

  return (
    <NavLink
      id={`main-menu-${menuItem.id}`}
      onClick={menuItem.onClick}
      onFocus={handlePrefetch}
      onMouseEnter={handlePrefetch}
      to={`/farm/${farmId}/${menuItem.route}`}
      className={({ isActive }) =>
        `${classes.menuItemLink} ${mobile ? classes.menuItemLinkMobile : ""} ${
          isActive ? classes.active : ""
        }`
      }
    >
      <span
        className={
          mobile ? classes.navlinkContentMobile : classes.navlinkContentDesktop
        }
      >
        {mobile && <Icon className={classes.navlinkIcon} />}
        <FormattedMessage id={menuItem.translationId} />
        {menuItem.suffix}
      </span>
    </NavLink>
  );
};

export { MainMenuItem };
